<template>
  <div class="general-info">
    <HeadLine>
      {{$ml.get('General Information')}}
    </HeadLine>
    <div class="th-fields-container">
      <div class="column">
        <ValueField :label="$ml.get('Name')" :value="section.data.name ? section.data.name : '-'"/>
        <ValueField :label="$ml.get('Farm')" :value="section.data.farmName ? section.data.farmName : '-'"/>
        <ValueField :label="$ml.get('Crop')" :value="$ml.get(section.data.crop.name)"/>
        <ValueField :label="$ml.get('Tissue sampled')" :value="$ml.get(section.data.test.tissue)"/>
      </div>
      <div class="column">
        <ValueField :label="$ml.get('Date')" :value="section.data.date == 0 ? '-' : section.data.date"/>
        <ValueField :label="$ml.get('Field')" :value="section.data.fieldName ? section.data.fieldName : '-'"/>
        <ValueField :label="$ml.get('Type sampled')" :value="$ml.get(section.data.test.variety)"/>
        <ValueField :label="$ml.get('Sampling time')" :value="$ml.get(section.data.test.samplingTime)"/>
      </div>
    </div>
  </div>
</template>

<script>
import HeadLine from './../../components/common/HeadLine';
import ValueField from './../../components/common/ValueField';
export default {
  computed: {

    section() {
      return this.$root.data.tissueTest;
    },

    field() {
      return this.$root.data.program.field
    },

    farm() {
      return this.$root.data.program.farm
    },
  },
  components: {
    HeadLine,
    ValueField,
  },
}
</script>

<style lang="scss" scoped>

.general-info {
  .head-line {
    margin-bottom: 10px;
  }

  .th-fields-container {
    margin-bottom: 20px;
  }
}

</style>